	<div class="input-group mb-0">
	<input
		id="typeahead-focus"
		type="text"
		[editable]="false"
		class="form-control"
		[ngModel]="value"
		(ngModelChange)="onInputChange($event)"
		[ngbTypeahead]="search"
		placement="bottom-right"
		(focus)="focus$.next($any($event).target.value)"
		(click)="click$.next($any($event).target.value)"
		#instance="ngbTypeahead"
	/>
  <span class="input-group-text" id="basic-addon2"><a href="#" (click)="searchClick.emit()" class="btn btn-outline-secondary"><i class="bi bi-search"></i></a></span>
</div>
